import { createAsyncThunk } from "@reduxjs/toolkit";
import { 
  getScreens, 
  getLocalization, 
  addLocalization as postLocalization, 
  updateLocalization as putLocalization, 
  deleteLocalization as removeLocalization, 
  UpdateColumnPreference,
  getTableColumnNames,
  addScreens,
  updateScreens,
  deleteScreens
} from "../../helpers/fakebackend_helper";
import { toast } from "react-toastify";
import { t } from "i18next";

// Fetch screens
export const fetchScreens = createAsyncThunk("screens/fetch", async (_, thunkAPI) => {
  try {
    const response = await getScreens();
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error || "Something went wrong");
  }
});

// Update user preferences
export const updateUserPreference = createAsyncThunk(
  "localization/updatePreference",
  async (preferences, thunkAPI) => {
    try {
      const response = await UpdateColumnPreference(preferences);
      toast.success(t(response.message));
      return response.data;
    } catch (error) {
      toast.error(error.message);
      return thunkAPI.rejectWithValue(error || "Something went wrong");
    }
  }
);

// Fetch localization data
export const fetchLocalization = createAsyncThunk("localization/fetch", async (localization, thunkAPI) => {
  
  try {
    const response = await getLocalization(localization);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error || "Something went wrong");
  }
});

// Add localization data
export const createLocalization = createAsyncThunk("localization/add", async (localization, thunkAPI) => {  
  try {
    const response = await postLocalization(localization);

    if (response.success) {
      toast.success(t(response.message));
    }else{
      toast.error(t(response.message));
    }    

    return response;
  } catch (error) {
    toast.error(error.message);
    return thunkAPI.rejectWithValue(error || "Something went wrong");
  }
});

// Update localization data
export const updateLocalization = createAsyncThunk("localization/update", async (localization, thunkAPI) => {
  try {
    const response = await putLocalization(localization);
    toast.success(t(response.message));
    return response.data;
  } catch (error) {
    toast.error(error.message);
    return thunkAPI.rejectWithValue(error || "Something went wrong");
  }
});

// Delete localization data
export const deleteLocalization = createAsyncThunk("localization/delete", async (localization, thunkAPI) => {
  try {
    const response = await removeLocalization(localization);
    toast.success(t(response.message));
    return response.data;
  } catch (error) {
    toast.error(error.message);
    return thunkAPI.rejectWithValue(error || "Something went wrong");
  }
});

export const fetchLocalizationTableColumnNames = createAsyncThunk(
  "localization/fetchTableColumnNames",
  async (localization, thunkAPI) => {
    try {
      const response = await getTableColumnNames(localization);      
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error || "Something went wrong");
    }
  }
);

//Screens manage

export const fetchScreenTableColumnNames = createAsyncThunk(
  "screen/fetchTableColumnNames",
  async (screen, thunkAPI) => {
    try {
      const response = await getTableColumnNames(screen);      
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error || "Something went wrong");
    }
  }
);

// Add localization data
export const createScreen = createAsyncThunk("screen/add", async (screen, thunkAPI) => {  
  try {
    const response = await addScreens(screen);
    toast.success(t(response.message));
    return response;
  } catch (error) {
    toast.error(error.message);
    return thunkAPI.rejectWithValue(error || "Something went wrong");
  }
});

export const updateScreen = createAsyncThunk("screen/update", async (screen, thunkAPI) => {  
  try {
    const response = await updateScreens(screen);
    toast.success(t(response.message));
    return response.data;
  } catch (error) {
    toast.error(error.message);
    return thunkAPI.rejectWithValue(error || "Something went wrong");
  }
});

// Delete localization data
export const deleteScreen = createAsyncThunk("screen/delete", async (screen, thunkAPI) => {
  try {
    const response = await deleteScreens(screen);
    toast.success(t(response.message));
    return response.data;
  } catch (error) {
    toast.error(error.message);
    return thunkAPI.rejectWithValue(error || "Something went wrong");
  }
});